import { render, staticRenderFns } from "./FooterButton.vue?vue&type=template&id=ae9f5fa8&scoped=true&lang=pug&"
import script from "./FooterButton.vue?vue&type=script&lang=js&"
export * from "./FooterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9f5fa8",
  null
  
)

export default component.exports